module.exports = __webpack_public_path__ + "img/whats_app.c191d103.png";